import PropTypes from 'prop-types';
import { useMedia } from 'react-use';
import styled from 'styled-components';
import SuccessPageAttribution from 'views/PostEnrollment/SuccessPageAttribution';
import SuccessPageButton from 'views/PostEnrollment/SuccessPageButtons';

import pay_anyone_phone from 'assets/images/success_page/pay_anyone_phone.png';

import Layout from 'components/Layout';
import StepHeader from 'components/StepHeader';

import { DescriptionText, PageTitle } from 'styles/styleMixins';

import { screenSizes } from 'theme/screenSizes';

const ContentWrapper = styled.div`
  text-align: center;
  margin-bottom: 22px;
`;

const CardImage = styled.div`
  background-image: url(${pay_anyone_phone});
  background-position: top center;
  background-repeat: no-repeat;
  background-size: ${props => (props.isMobile ? '274px' : '302px')};
  width: 100%;
  height: ${props => (props.isMobile ? '475px' : '282px')};
  margin-bottom: ${props => (props.isMobile ? '0' : '-35px')};
`;

const P2PSuccessPage = ({ routeObj }) => {
  const isTablet = useMedia(`(max-width: ${screenSizes.tablet}px)`);

  return (
    <SuccessPageAttribution>
      <Layout routeObj={routeObj}>
        <main role="main">
          <ContentWrapper>
            <StepHeader>
              <PageTitle>All set!</PageTitle>
              <DescriptionText>
                Download the app to finish setting up your account.
              </DescriptionText>
            </StepHeader>
            <SuccessPageButton
              justifyContent="center"
              eventContext="p2p_success"
            />
          </ContentWrapper>
          <CardImage isMobile={isTablet} />
        </main>
      </Layout>
    </SuccessPageAttribution>
  );
};

P2PSuccessPage.propTypes = {
  routeObj: PropTypes.shape({
    index: PropTypes.number,
    name: PropTypes.string,
    path: PropTypes.string,
  }),
};

export default P2PSuccessPage;
